
import Vue from 'vue';
import axios from 'axios';
import EventService from '@/services/EventService';
import {mapState} from 'vuex';
import TwoDVideo from '@/components/2dvideo.vue';
import AuditHistorySnackbars from '@/components/AuditHistorySnackbars.vue';
import store from '../store';
import type {User as AuthUser} from 'firebase/auth';

const baseURL = EventService.ProtoURL();
const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

type Question = {
  answer: string;
  choice: {
    a: string;
    b: string;
  };
  show: string;
  commentary: {
    a: string;
    b: string;
  };
};

type User = {
  name: string;
  kana?: string;
  id: string;
  done: boolean; // 今回の表示中に視聴完了 (初期表示時のサーバーからのリクエストには含まれていない)
  check: boolean;
  disabled: boolean;
};

type Data = {
  checkbox: boolean;
  number: number;
  users: Array<User>;
  doneUserIDs: Set<string>;
  messages: Array<string>;
  played: boolean;
  question: Question;
  choice: '' | 'A' | 'B';
};

type Method = {
  trainingID(): string;
  updateUserStatus(): Promise<void>;
  jump(id: string): void;
  set(active: boolean, user: User): boolean;
  toggleCheckbox(user: User): void;
};

type Computed = {
  isAnyUserChecked: boolean;
  user: AuthUser | undefined;
};

type Props = {
  year: string;
};

export default Vue.extend<Data, Method, Computed, Props>({
  name: 'tow-d-movies-users',
  components: {
    TwoDVideo,
    AuditHistorySnackbars,
  },
  props: {
    year: {
      type: String,
      default: '',
    },
  },
  computed: {
    isAnyUserChecked() {
      const ret = this.users.some((user: User) => {
        return user.check && !user.disabled;
      });
      console.log('isAnyUserChecked', ret);
      return ret;
    },
    ...mapState(['user']),
  },
  methods: {
    trainingID(): string {
      // return ((parseInt(this.$route.params['id']) - 1) % 12) + 1; /* FIXME */
      return this.$route.params['id'];
    },
    async updateUserStatus() {
      const id = this.$route.params['id'];
      const checkedNotDoneUsers = this.users.filter((user: User) => {
        return user.check && !this.doneUserIDs.has(user.id);
      });
      checkedNotDoneUsers.forEach((user: User) => {
        user.disabled = true;
      });
      const checkedUserIds = checkedNotDoneUsers.map((user: User) => {
        return user.id;
      });
      console.log(checkedUserIds);
      try {
        const token = await this.user?.getIdToken();
        await EventService.putUsersStatus(token, id, checkedUserIds);
        checkedNotDoneUsers.forEach((user: User) => {
          this.doneUserIDs.add(user.id);
          user.done = true;
        });
        this.messages = ['選択したユーザーの研修を完了状態にしました'];
      } catch (err) {
        // DB更新失敗したので元に戻す
        checkedNotDoneUsers.forEach((user: User) => {
          user.disabled = false;
        });
        console.log(err);
      }
    },
    jump(id: string) {
      this.$router.push(`/2d/${id}?year=${this.year}`);
    },
    set(active: boolean, user: User): boolean {
      console.log(active);
      return user.check;
    },
    toggleCheckbox(user: User) {
      if (user.disabled) {
        return;
      }
      user.check = !user.check;
    },
  },
  data: (): Data => ({
    checkbox: false,
    number: 12,
    users: [] as User[],
    doneUserIDs: new Set<string>(),
    messages: [],
    played: false,
    question: {
      answer: '',
      show: '',
      choice: {
        a: '',
        b: '',
      },
      commentary: {
        a: '',
        b: '',
      },
    },
    choice: '',
  }),
  async mounted() {
    if (this.user) {
      const token = await this.user.getIdToken();
      try {
        const {data} = await apiClient.get(`/2d/users/?year=${this.year}`, {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.users = data;
        this.users = this.users.filter(user => user.name !== 'Guest');
        var sortUser = (a: User, b: User) => {
          if (a.kana == undefined) {
            return 1;
          }
          if (b.kana == undefined) {
            return -1;
          }
          if (a.kana < b.kana) {
            return -1;
          }
          if (a.kana > b.kana) {
            return 1;
          }
          return 0;
        };
        this.users.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.users.sort(sortUser);
        this.users = this.users.map((user: Omit<User, 'check'>) => ({
          ...user,
          check: this.checkbox,
          disabled: false,
        }));
      } catch (e) {
        console.log(e);
      }
      try {
        const id = this.$route.params['id'];
        const {data} = await apiClient.get(`/2d/trainings/${id}`, {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.question = {
          answer: data.answer,
          show: data.show,
          choice: data.choice,
          commentary: {
            a: data.commentary.a.replace(/\\n/g, '<br>'),
            b: data.commentary.b.replace(/\\n/g, '<br>'),
          },
        };
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    checkbox(val) {
      this.users.map((user: User) => {
        if (user.disabled) {
          return;
        }
        user.check = val;
      });
    },
  },
});
